/* src/app/ai-sourcing/ai-sourcing-archive/ai-sourcing-archive.component.scss */
#overlay {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 6;
  top: 0;
  left: 0px;
  background-color: #000;
  opacity: 0.4;
  overflow-x: hidden;
  transition: 0.5s;
  padding: 30px;
  display: none;
}
#quickView {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 6;
  top: 0;
  right: -60px;
  background-color: #fff;
  overflow-x: hidden;
  transition: 0.5s;
  padding: 0px 0px;
}
.more-ai-matched-card {
  border: 1px solid #9CD1FF;
  background:
    linear-gradient(
      90deg,
      rgba(249, 200, 216, 0.9098039216) -1.65%,
      #ffffff 80%);
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.more-ai-matched-card p {
  font-size: 11px;
  font-weight: normal;
  line-height: 1;
  font-style: italic;
  color: #000000;
  margin-bottom: 0;
}
.more-ai-matched-card .btn-get-more-candidate {
  background-color: #F2F2F2;
  color: #969696;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 8px;
  border: 1px solid #969696;
  outline: none;
}
.more-ai-matched-card .btn-get-more-candidate:focus {
  outline: none;
}
.more-ai-matched-card .btn-get-more-candidate.active {
  background-color: #ffffff;
  color: #C845AB;
  border: 1px solid #C845AB;
}
.img-config {
  width: 100%;
}
.wc-checkbox {
  width: 14px !important;
  height: 14px !important;
  margin-top: 3px;
}
.wc-checkbox input[type=checkbox] {
  width: 14px !important;
  height: 14px !important;
}
.wc-checkbox input[type=checkbox]:checked ~ i {
  background-color: #2e93a1;
  border: 1px solid #2e93a1;
  transition: 0.5s;
}
.wc-checkbox i {
  width: 100%;
  height: 100%;
  background-color: #fff;
  color: #FFF;
  border: 1px solid #2e93a1;
  border-radius: 2px;
}
@media only screen and (max-width: 1368px) {
  .wc-checkbox {
    width: 14px !important;
    height: 14px !important;
  }
  .wc-checkbox input[type=checkbox] {
    width: 14px !important;
    height: 14px !important;
  }
  .wc-checkbox input[type=checkbox]:checked ~ i {
    background-color: #2e93a1;
    border: 1px solid #2e93a1;
    transition: 0.5s;
  }
  .wc-checkbox i {
    width: 100%;
    height: 100%;
    background-color: #fff;
    color: #FFF;
    border: 1px solid #2e93a1;
    border-radius: 2px;
  }
}
.img-config-review {
  width: 170px;
  height: 130px;
}
.alert-dismissible .btn-close {
  display: none !important;
}
/*# sourceMappingURL=ai-sourcing-archive.component-33W5L2F2.css.map */
